import React from 'react';
import styled from 'styled-components';

import { Outlets } from './outlets.component';
import { Outlet } from './types/outlet.type';
import { ChangeSortOptions } from '../utils/hooks/useSort';

interface Props {
    outlets: Record<string, Outlet[]>;
    onSort: ChangeSortOptions;
    onEditOutlets?: () => void;
}

export function OutletList({ outlets, onSort, onEditOutlets }: Props) {
    const outletsArray = Object.entries(outlets || {});
    return (
        <Container>
            <div className="outlet-list-header">
                {onEditOutlets && (
                    <button className="wfp-btn edit-outlets-btn" onClick={onEditOutlets} type="button">
                        Update Vendors
                    </button>
                )}
            </div>
            <table className="wfp-table">
                {outletsArray.length ? (
                    <>
                        <Outlets onSort={onSort} outlets={outletsArray} />
                    </>
                ) : (
                    <tr>
                        <td colSpan={7}>
                            <p>
                                <strong>No outlets found</strong>
                            </p>
                        </td>
                    </tr>
                )}
            </table>
        </Container>
    );
}
const Container = styled.div`
    display: grid;
    padding-bottom: 1rem;

    .outlet-list-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1rem;

        h3 {
            margin: 0;
            color: rgba(55, 55, 55, 0.8);
            font-size: 1.2rem;
            font-weight: 700;
        }

        .edit-outlets-btn {
            margin-left: auto;
            padding: 0.5rem 1rem;
            cursor: pointer;
            transition: background-color 0.2s;
        }
    }

    table {
        table-layout: fixed;
        .col-width {
            width: 300px;
        }
        thead tr th {
            background: rgba(238, 246, 255, 1);
        }
    }
    h6 {
        color: rgba(55, 55, 55, 0.8);
        font-size: 1rem;
        font-weight: 700;
    }
`;
